var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ButtonFieldIcon } from '../button-field-icon';
import { Iconsvg } from '../iconsvg';
import { SrOnly } from '../sr-only';
import { componentApi } from '../component-api-lib';
import * as React from 'react';
var DropdownMoreButton = /** @class */ (function (_super) {
    __extends(DropdownMoreButton, _super);
    function DropdownMoreButton(props) {
        var _this = _super.call(this, props) || this;
        _this.emit = componentApi.emit.bind(_this);
        _this.buttonClick = 'onButtonClick';
        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }
    DropdownMoreButton.prototype.render = function () {
        var _this = this;
        return (React.createElement(ButtonFieldIcon, { size: this.props.size },
            React.createElement("button", { id: this.props.buttonId, disabled: this.props.isDisabled, "data-e2e": "cg-dropdown-toggle", "aria-describedby": this.props.srDescribedby, type: "button", onClick: function (event) { return _this.onClick(event); }, className: 'cg-dropdown-toggle ' +
                    (this.props.mode === 'blue' ? 'cg-is-button-more ' : '') },
                React.createElement(Iconsvg, { name: "more", isFill: true }),
                React.createElement(SrOnly, null, this.props.i18n.more))));
    };
    DropdownMoreButton.prototype.onClick = function (event) {
        this.emit(this.buttonClick);
    };
    DropdownMoreButton.defaultProps = {
        size: 'large16px',
        isDisabled: false,
        i18n: {
            more: 'More',
        },
        srDescribedby: '',
        buttonId: '',
        mode: 'gray',
    };
    DropdownMoreButton.displayName = 'DropdownMoreButton';
    return DropdownMoreButton;
}(React.Component));
export { DropdownMoreButton };
